// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-reminder-modal[data-v-fbaf6494]{margin:0 12px}`, "",{"version":3,"sources":["webpack://./apps/files_reminders/src/components/SetCustomReminderModal.vue"],"names":[],"mappings":"AACA,wCACC,aAAA","sourcesContent":["\n.custom-reminder-modal {\n\tmargin: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
